"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fieldset = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../../../Layout/Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fieldset = function Fieldset(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'group' : _b,
      sx = _a.sx,
      props = (0, _tslib.__rest)(_a, ["variant", "sx"]);
  return _react.default.createElement(_Box.default, (0, _tslib.__assign)({
    __themekey: "forms",
    sx: (0, _tslib.__assign)({
      padding: 0,
      marginBottom: 4,
      border: 'none',
      '&:focus': {
        outline: '1px dotted slategrey'
      },
      '&:focus-within': {
        outline: '1px dotted slategrey'
      }
    }, sx),
    variant: variant
  }, props));
};

exports.Fieldset = Fieldset;